import { ExceptionList, Link } from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";

const supportEmail = "dmoda-sync@jef.it";

export function FullPageError({ title = "An Error occurred" }: { title?: string }) {
  // const queryParams = new URLSearchParams({
  //   subject: ,
  // });

  const supportEmailUrl = `mailto:${supportEmail}?subject=DModa Sync | Support | ${title}`;
  return (
    <div className="full-page">
      <ExceptionList
        items={[
          {
            title,
            status: "critical",
            icon: NoteIcon,
            description: (
              <span>
                Something went wrong, try <Link onClick={() => window.location.reload()}>reload</Link> or{" "}
                <Link target="_blank" url={supportEmailUrl}>
                  contact support
                </Link>
              </span>
            ),
          },
        ]}
      />
    </div>
  );
}
